import React from "react";
import ApplicationFilter from "./filters/ApplicationFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  CLEAR_SYS_GUARD_FILTERS,
  GET_SYS_GUARD_APPLICATION,
  GET_SYS_GUARD_LOCATION,
  GET_SYS_GUARD_USERS,
  SET_SELECTED_RISK_FACTOR,
  SET_SELECTED_MFA,
  SET_SELECTED_USER,
  SET_SYS_GUARD_SELECTED_APPLICATIONS,
  SET_SYS_GUARD_SELECTED_COUNTRIES,
  SET_SYS_GUARD_THREAT_PROBABILITIES,
} from "../../sysGuardConstants";

export default function SysGuardFilter({
  loc,
  dataSourceId,
  pageSize,
  currentPage,
  popupClose,
  filterField,
}) {
  const dispatch = useDispatch();
  const {
    sysGuardSelectedApplications: appNamesFilter = [],
    sysGuardSelectedCountryNames: countryNameFilter = [],
    sysGuardSelectedThreatProbabilities: threatFilter = [],
    sysGuardSelectedUserName: userNameFilter,
    sysGuardSelectedMFAList: MFAFilter,
    sysGuardSelectedRiskFactorList: RiskFactorFilter,
    incognito: isIncognito,
  } = useSelector((state) => state.SysGuardReducer);

  const getTableParamDataDispatch = (selectedFilters) => {
    const filtersMap = {
      applicationName: appNamesFilter,
      countryNames: countryNameFilter,
      countryName: countryNameFilter,
      countryRisk: threatFilter,
      userName: userNameFilter,
      mfa: MFAFilter,
      userRisk: RiskFactorFilter,
    };

    const finalFilters = {
      applicationName:
        filterField === "applicationName"
          ? selectedFilters
          : filtersMap.applicationName,
      countryNames: ["countryNames", "countryName"].includes(filterField)
        ? selectedFilters
        : filtersMap.countryNames,
      threatFields:
        filterField === "countryRisk"
          ? selectedFilters
          : filtersMap.countryRisk,
      userFields:
        filterField === "userName" ? selectedFilters : filtersMap.userName,
      MFAFields: filterField === "mfa" ? selectedFilters : filtersMap.mfa,
      RiskFactorFields:
        filterField === "userRisk" ? selectedFilters : filtersMap.userRisk,
    };

    const basePayload = {
      id: dataSourceId,
      currentPage,
      pageSize,
    };

    const locDispatchMap = {
      Applications: () =>
        dispatch({
          type: GET_SYS_GUARD_APPLICATION,
          payload: {
            ...basePayload,
            applicationName: finalFilters.applicationName,
            countryNames: finalFilters.countryNames,
          },
        }),
      Users: () =>
        dispatch({
          type: GET_SYS_GUARD_USERS,
          payload: {
            ...basePayload,
            isIncognito,
            userFields: finalFilters.userFields,
            MFAFields: finalFilters.MFAFields,
            RiskFactorFields: finalFilters.RiskFactorFields,
          },
        }),
      Locations: () =>
        dispatch({
          type: GET_SYS_GUARD_LOCATION,
          payload: {
            ...basePayload,
            countryNames: finalFilters.countryNames,
            threatFields: finalFilters.threatFields,
          },
        }),
    };

    locDispatchMap[loc]?.();
  };

  const getTableDataDispatch = () => {
    const basePayload = { id: dataSourceId, currentPage, pageSize };
    const locDispatchMap = {
      Applications: () =>
        dispatch({ type: GET_SYS_GUARD_APPLICATION, payload: basePayload }),
      Users: () =>
        dispatch({
          type: GET_SYS_GUARD_USERS,
          payload: { ...basePayload, isIncognito },
        }),
      Locations: () =>
        dispatch({ type: GET_SYS_GUARD_LOCATION, payload: basePayload }),
    };

    locDispatchMap[loc]?.();
  };

  const handleApply = (selectedFilters) => {
    popupClose();
    getTableParamDataDispatch(selectedFilters);
  };

  const handleCancel = () => {
    popupClose();
  };

  const handleClear = () => {
    popupClose();
    dispatch({ type: CLEAR_SYS_GUARD_FILTERS });
    getTableDataDispatch();
  };

  const validFilters = [
    "userName",
    "mfa",
    "userRisk",
    "countryRisk",
    "countryName",
    "countryNames",
    "applicationName",
  ];
  const filterConfigMap = {
    applicationName: {
      listSelector: (state) => state.SysGuardReducer.sysGuardApplicationNames,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedApplications || [],
      actionType: SET_SYS_GUARD_SELECTED_APPLICATIONS,
    },
    countryNames: {
      listSelector: (state) => state.SysGuardReducer.sysGuardCountryNames,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedCountryNames || [],
      actionType: SET_SYS_GUARD_SELECTED_COUNTRIES,
      isCountry: true,
    },
    countryName: {
      listSelector: (state) => state.SysGuardReducer.sysGuardCountryNames,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedCountryNames || [],
      actionType: SET_SYS_GUARD_SELECTED_COUNTRIES,
      isCountry: true,
    },
    countryRisk: {
      listSelector: (state) =>
        state.SysGuardReducer.sysGuardThreatProbabilityList,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedThreatProbabilities || [],
      actionType: SET_SYS_GUARD_THREAT_PROBABILITIES,
      isRisk: true,
    },
    userName: {
      listSelector: (state) => state.SysGuardReducer.sysGuardUniqueUserList,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedUserName || [],
      actionType: SET_SELECTED_USER,
    },
    mfa: {
      listSelector: (state) => state.SysGuardReducer.sysGuardMFAList,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedMFAList || [],
      actionType: SET_SELECTED_MFA,
    },
    userRisk: {
      listSelector: (state) => state.SysGuardReducer.sysGuardRiskFactorList,
      selectedSelector: (state) =>
        state.SysGuardReducer.sysGuardSelectedRiskFactorList || [],
      actionType: SET_SELECTED_RISK_FACTOR,
      isRisk: true,
    },
  };

  return (
    <div>
      {validFilters.includes(filterField) ? (
        <ApplicationFilter
          onApply={handleApply}
          onCancel={handleCancel}
          onClear={handleClear}
          filterField={filterField}
          customFilterConfigMap={filterConfigMap}
        />
      ) : (
        <div>No filter for now</div>
      )}
    </div>
  );
}
